import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
const PURCHASES = [{
  name: 'Lucía M.',
  time: 'hace 2 minutos'
}, {
  name: 'Martín G.',
  time: 'hace 5 minutos'
}, {
  name: 'Sofía R.',
  time: 'hace 12 minutos'
}, {
  name: 'Diego F.',
  time: 'hace 18 minutos'
}, {
  name: 'Camila T.',
  time: 'hace 25 minutos'
}, {
  name: 'Valentina S.',
  time: 'hace 32 minutos'
}, {
  name: 'Joaquín P.',
  time: 'hace 41 minutos'
}, {
  name: 'Agustina L.',
  time: 'hace 55 minutos'
}];
// 30s cycle: visible 5s, hidden 25s
const VISIBLE_MS = 5000;
const HIDDEN_MS = 25000;
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const dismissedRef = useRef(false);
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const tick = (showing: boolean) => {
      if (showing) {
        setIsVisible(false);
        timer = setTimeout(() => tick(false), HIDDEN_MS);
      } else {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setIsVisible(true);
        timer = setTimeout(() => tick(true), VISIBLE_MS);
      }
    };
    // First popup after 5 seconds
    timer = setTimeout(() => tick(false), 5000);
    return () => clearTimeout(timer);
  }, []);
  const currentPurchase = PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-22">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.25,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto bg-white rounded-xl shadow-lg border border-gray-100 p-4 pr-10" data-id="element-23">
          <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-24">
            <X size={16} data-id="element-25" />
          </button>

          <div className="flex items-start gap-3" data-id="element-26">
            <div className="flex-shrink-0 w-10 h-10 bg-salvia-light rounded-full flex items-center justify-center text-salvia font-bold text-sm" data-id="element-27">
              {currentPurchase.name.substring(0, 2).toUpperCase()}
            </div>
            <div data-id="element-28">
              <div className="flex items-center gap-1.5 mb-1" data-id="element-29">
                <p className="text-sm font-bold text-oscuro" data-id="element-30">
                  {currentPurchase.name}
                </p>
                <CheckCircle size={14} className="text-salvia" data-id="element-31" />
              </div>
              <p className="text-xs text-gray-600 mb-1" data-id="element-32">
                acaba de comprar YOGA 360
              </p>
              <p className="text-[10px] text-gray-400 font-medium" data-id="element-33">
                {currentPurchase.time}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}